import React from "react"

import { ProjectGroupFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchProjectGroup {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: ProjectGroupFilters
    onFilter: (filters: ProjectGroupFilters) => void
}

const ProjectGroupSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchProjectGroup) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default ProjectGroupSearch
